/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['pusnaktī', 'pusd.', 'no rīta', 'pēcpusdienā', 'vakarā', 'naktī'],
    ['pusnaktī', 'pusd.', 'no rīta', 'pēcpusd.', 'vakarā', 'naktī'],
    ['pusnaktī', 'pusdienlaikā', 'no rīta', 'pēcpusdienā', 'vakarā', 'naktī']
  ],
  [
    ['pusnakts', 'pusd.', 'rīts', 'pēcpusd.', 'vakars', 'nakts'],
    ['pusnakts', 'pusd.', 'rīts', 'pēcpusdiena', 'vakars', 'nakts'],
    ['pusnakts', 'pusdienlaiks', 'rīts', 'pēcpusdiena', 'vakars', 'nakts']
  ],
  [
    '00:00', '12:00', ['06:00', '12:00'], ['12:00', '18:00'], ['18:00', '23:00'],
    ['23:00', '06:00']
  ]
];
